const ANIMATION_VELOCITY_PER_SECOND = 1100;

export function calculateAnimationDuration(pixels) {
  return (1000 * Math.abs(pixels)) / ANIMATION_VELOCITY_PER_SECOND;
}
